"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Audio_exports = {};
__export(Audio_exports, {
  default: () => Audio_default
});
module.exports = __toCommonJS(Audio_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M15.8125 4.625C16.5417 5.40625 17.0885 6.28516 17.4531 7.26172C17.8177 8.23828 18 9.23438 18 10.25C18 11.2656 17.8177 12.2617 17.4531 13.2383C17.0885 14.2148 16.5417 15.0938 15.8125 15.875C15.6823 16.0182 15.526 16.0898 15.3438 16.0898C15.1615 16.0898 14.9987 16.0182 14.8555 15.875C14.7253 15.7318 14.6602 15.5625 14.6602 15.3672C14.6602 15.1589 14.7253 14.9831 14.8555 14.8398C15.4544 14.2148 15.9036 13.4987 16.2031 12.6914C16.5026 11.8971 16.6523 11.0833 16.6523 10.25C16.6523 9.41667 16.5026 8.60286 16.2031 7.80859C15.9036 7.0013 15.4544 6.28516 14.8555 5.66016C14.7253 5.51693 14.6602 5.34766 14.6602 5.15234C14.6602 4.94401 14.7253 4.76823 14.8555 4.625C14.9987 4.48177 15.1615 4.41016 15.3438 4.41016C15.526 4.41016 15.6823 4.48177 15.8125 4.625ZM10.9102 5.19141V15.3086C10.9102 15.6081 10.7734 15.8294 10.5 15.9727C10.2396 16.1029 9.99219 16.0703 9.75781 15.875L6.33984 13.1406H3.72266C3.52734 13.1406 3.35807 13.069 3.21484 12.9258C3.07161 12.7826 3 12.6133 3 12.418V8.08203C3 7.88672 3.07161 7.71745 3.21484 7.57422C3.35807 7.43099 3.52734 7.35938 3.72266 7.35938H6.33984L9.75781 4.625C9.99219 4.42969 10.2396 4.40365 10.5 4.54688C10.7734 4.67708 10.9102 4.89193 10.9102 5.19141ZM9.48438 6.69531L7.04297 8.64844C6.97786 8.70052 6.90625 8.73958 6.82812 8.76562C6.76302 8.79167 6.6849 8.80469 6.59375 8.80469H4.44531V11.6953H6.59375C6.6849 11.6953 6.76302 11.7083 6.82812 11.7344C6.90625 11.7604 6.97786 11.7995 7.04297 11.8516L9.48438 13.8047V6.69531ZM13.3906 7.125C13.8203 7.55469 14.1393 8.04297 14.3477 8.58984C14.556 9.13672 14.6602 9.6901 14.6602 10.25C14.6602 10.8099 14.556 11.3633 14.3477 11.9102C14.1393 12.457 13.8203 12.9453 13.3906 13.375C13.2604 13.5182 13.0911 13.5898 12.8828 13.5898C12.6875 13.5898 12.5182 13.5182 12.375 13.375C12.2318 13.2318 12.1602 13.056 12.1602 12.8477C12.1602 12.6393 12.2318 12.4635 12.375 12.3203C12.9349 11.7474 13.2148 11.0573 13.2148 10.25C13.2148 9.44271 12.9349 8.7526 12.375 8.17969C12.2318 8.03646 12.1602 7.86068 12.1602 7.65234C12.1602 7.44401 12.2318 7.26823 12.375 7.125C12.5182 6.98177 12.6875 6.91016 12.8828 6.91016C13.0911 6.91016 13.2604 6.98177 13.3906 7.125Z",
      fill: "currentColor"
    }
  )
);
const SvgAudio = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Audio_default = SvgAudio;
